import React, { useState } from 'react'
import Button from '../../../../../components/Buttons/Button'
import EmptyData from '../../../../../components/EmptyData'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useQuery } from 'react-query';
import { api } from '../../../../../api/learningPath';
import { useNavigate, useParams } from 'react-router';
import Pagination from '../../../../../components/pagination/Pagination';
import Table from '../../../../../components/table/Table';
import Loader from '../../../../../components/loader/Loader';
import { v4 } from 'uuid';

const SurveyResponse = () => {
    const [perPage, setPerPage] = useState<number>(5);
    const [search, setSearch] = useState<string>("");
    const [currentPage, setCurrentPage] = useState<number>(1);
    const navigate = useNavigate()
    const orgId = JSON.parse(sessionStorage.getItem("user")!)?.org?.id;
    const {cohortId, actionPlanId, surveyId, responseId} = useParams()

   const path: any = -1

   const {
             data: surveyResponses,
             isLoading,
           } = useQuery(
             ["action plans learners", orgId],
             () => {
               return api.getSurveyResponse({
                 id: orgId,
                 cohortId,
                 surveyId,
                 responseId,
                 actionPlanId
               });
             },
             {
               staleTime: 3000,  
               cacheTime: 3000,  
               select: (data) => data?.data?.responses,
             }
           );

           console.table(surveyResponses);
           

          let columns = React.useMemo( () => [
                      {
                        title: "ID",
                        selector: null,
                        key: "id",
                        render: ({ index } : {index: number}) =>
                          index +
                          1 +
                          ((surveyResponses?.meta?.page || 1) - 1) * (surveyResponses?.meta?.perPage || perPage ),
                      },
                      {
                          title: "Question",
                          selector: 'question',
                          key: 'question',
                          render: ({ item } : any) => {                      
                              return( 
                                  <span>
                                     {item}
                                  </span>
                              )
                          },
                        },
                        {
                          title: "Type",
                          selector: 'type',
                          key: 'type',
                          render: ({ item } : any) => {                      
                              return( 
                                  <span>
                                     {item}
                                  </span>
                              )
                          },
                        },
                      {
                          title: "Options",
                          selector: "choices",
                          key: "choices",
                          render: ({ item, } : any) => {                      
                              return item?.length  ?
                                item?.map((item: any, index: number) => (
                                  ( 
                                    <span key={v4()} className="">
                                       <span className='underline mr-3 text-xs'>
                                           {item}
                                        </span> 
                                  </span>
                                )
                                ))
                              : '----'
                          },
                        },
                        {
                          title: "Answers",
                          selector: "answer",
                          key: "answer",
                          render: ({ item, } : any) => {                      
                              return (item?.length && typeof item !== 'string')  ?
                                item?.map((item: any, index: number) => (
                                  ( 
                                    <span key={v4()} className="">
                                       <span className='underline mr-3 text-xs'>
                                           {item}
                                        </span> 
                                  </span>
                                )
                                ))
                              : item || '-----------'
                          },
                        },
                    ],[1, 20, 20]);

    const tableProps = { isLoading, columns, data: surveyResponses }

  return (
    <div className='mt-5'>
      <header className='flex justify-between'>
          <h2> Survey Response </h2>
          {
          //@ts-ignore
          <Button 
              renderAs='link' 
              to={path}
              text={'Back'}
              width={'w-[130px]'}
              bgColor={'bg-customBlue'}
          />
          }
      </header>   
      <div className='bg-white my-3'>
            <header className='flex justify-between py-3 shadow px-3 items-center'>
                <span className='text-sm'>Total Responses ({surveyResponses?.length})</span>
            </header>
              {
                isLoading ? <Loader /> :
                surveyResponses?.length ?
                  <Table {...tableProps} />
                :
                <EmptyData text={`There is no any survey response found`} />
              }
      </div>
    </div>
  )
}

export default SurveyResponse